var render = function render(){
  var _vm$organograma, _vm$organograma2, _vm$organograma3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Setor",
      "items": _vm.form.lists.setores,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.setor,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "setor", $$v);
      },
      expression: "form.filters.setor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função",
      "items": _vm.form.lists.funcoes,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.funcao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "funcao", $$v);
      },
      expression: "form.filters.funcao"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarProfissionais();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Atribuir Perfil em Lote',
      "icon": 'mdi-account-multiple-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogAtribuirPerfilEmLote();
      }
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-5 mb-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', [_vm._v("mdi mdi-pen")]), _vm._v(" Nome da Gerência: ")], 1), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s((_vm$organograma = _vm.organograma) === null || _vm$organograma === void 0 ? void 0 : _vm$organograma.nome))])])], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "mb-1"
  }, [_vm._v(" Sigla da Gerência: ")]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s((_vm$organograma2 = _vm.organograma) === null || _vm$organograma2 === void 0 ? void 0 : _vm$organograma2.sigla))])])], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', [_vm._v("mdi mdi-office-building-marker-outline")]), _vm._v(" Secretaria Executiva: ")], 1), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s((_vm$organograma3 = _vm.organograma) === null || _vm$organograma3 === void 0 ? void 0 : _vm$organograma3.secretariaExecutiva))])])], 1)], 1), _c('v-data-table', {
    ref: "table",
    staticClass: "mt-5",
    attrs: {
      "item-key": "id",
      "headers": _vm.headers,
      "items": _vm.form.lists.profissionais,
      "footer-props": _vm.$footerProps,
      "items-per-page": 10,
      "show-select": "",
      "show-expand": ""
    },
    on: {
      "item-expanded": _vm.obterPerfilProfissional
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nomeSocial || item.nome) + " ")];
      }
    }, {
      key: `item.setor`,
      fn: function (_ref2) {
        var _item$setor;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s((_item$setor = item.setor) === null || _item$setor === void 0 ? void 0 : _item$setor.nome) + " ")];
      }
    }, {
      key: `item.funcao`,
      fn: function (_ref3) {
        var _item$funcao;
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s((_item$funcao = item.funcao) === null || _item$funcao === void 0 ? void 0 : _item$funcao.nome) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref4) {
        var headers = _ref4.headers,
          item = _ref4.item;
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.perfis, function (perfil, i) {
          return _c('v-chip', {
            key: i
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(perfil.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Atribuir Perfil',
            "icon": 'mdi-account-multiple-plus',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogAtribuirPerfil(item);
            }
          }
        })];
      }
    }], null, true),
    model: {
      value: _vm.profissionaisSelecionados,
      callback: function ($$v) {
        _vm.profissionaisSelecionados = $$v;
      },
      expression: "profissionaisSelecionados"
    }
  })], 1), _c('AtribuirPerfilEmLoteDialog', {
    attrs: {
      "visible": _vm.dialogAtribuirPerfilEmLote.visible,
      "content": _vm.dialogAtribuirPerfilEmLote.content,
      "edit": _vm.dialogAtribuirPerfilEmLote.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogAtribuirPerfilEmLote.close();
      },
      "onSave": function ($event) {
        return _vm.buscarProfissionais();
      }
    }
  }), _c('AtribuirPerfilDialog', {
    attrs: {
      "visible": _vm.dialogAtribuirPerfil.visible,
      "content": _vm.dialogAtribuirPerfil.content,
      "edit": _vm.dialogAtribuirPerfil.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogAtribuirPerfil.close();
      },
      "onSave": function ($event) {
        return _vm.buscarProfissionais();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }